var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex align-center justify-space-between",class:{'above':_vm.position === 'above'}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"https://aplicacionesexcel.com/","target":"_blank"}},[_c('span',{staticClass:"hidden-xs-only"},[_vm._v("By 4PLBOX")]),_c('span',{staticClass:"hidden-sm-and-up"},[_vm._v("By 4PLBOX")])])])
}]

export { render, staticRenderFns }